/*
	ACTIONS
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import firebase from 'firebase/app';

//------------------------------------------------------------
// LOGOUT
// https://stackoverflow.com/questions/42764085/vue-app-and-firebase-authentication-using-vuex
//------------------------------------------------------------

const logout = ({commit}) => {
	// eslint-disable-next-line
	console.log('Actions: logging out');
	firebase.auth().signOut().then(() => {
		commit('LOGOUT');
	});
};

//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	logout,
};